import { majorToMinor } from '@eventbrite/intl';
import { Environment } from '@eventbrite/paypal-checkout-types';
import { logEvent } from '@eventbrite/statsig';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { PaymentMethodType } from '../../../..//models/paymentMethods/enums';
import { trackPaypalCTAClick } from '../../../../actions/eventAnalytics';
import { STATSIG_EVENT_NAMES } from '../../../../constants/statsig';
import { getIsProd } from '../../../../selectors/app';
import { getCurrency } from '../../../../selectors/event';
import { getUnformattedOrderCost } from '../../../../selectors/order';
import { getSelectedVirtualIncentives } from '../../../../selectors/virtualIncentive';
import { CheckoutState } from '../../../../state';
import { getTotalDiscountingVirtualIncentives } from '../../../../utils/virtualIncentives';
import {
    onPaypalAuthorize,
    onPaypalError,
} from '../../../paymentMethodSelector/PaymentPaypalActions';
import {
    PaypalButtonCallbackProps,
    PaypalButtonNonCallbackProps,
} from '../PaypalButton/PaypalButton';

const _mapStateToProps = (
    state: CheckoutState,
): PaypalButtonNonCallbackProps => ({
    amountCurrency: getCurrency(state) || 'USD',
    amountTotal:
        'costs' in state.order
            ? majorToMinor(
                  getTotalDiscountingVirtualIncentives(
                      getUnformattedOrderCost(state),
                      getSelectedVirtualIncentives(state),
                  ),
                  state.order.costs.gross.currency,
              )
            : 0,
    env: getIsProd(state) ? Environment.Production : Environment.Sandbox,
    paypalScriptStatus: state.paypal?.scriptStatus,
    isCheckoutButton: true,
});

const _mapDispatchToProps = <Action>(
    _dispatch: Dispatch<Action>,
): PaypalButtonCallbackProps => ({
    onPaypalAuthorize: onPaypalAuthorize(_dispatch),
    onPaypalClick: ({ fundingSource }) => {
        _dispatch(trackPaypalCTAClick(fundingSource));
        logEvent(
            STATSIG_EVENT_NAMES.CHECKOUT_STEP_PLACE_ORDER_CLICK,
            undefined,
            { payment_method: PaymentMethodType.NONCE_BRAINTREE },
        );
    },
    onPaypalError: onPaypalError(_dispatch),
});

export const connectPayPalButton = connect(
    _mapStateToProps,
    _mapDispatchToProps,
);
